import React, { useState, useEffect, Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import {
  Dropdown, Select, Table, Tag, Checkbox, Drawer, Popconfirm, Popover, Tooltip,
  Divider,
} from 'antd';
import {
  ControlOutlined, FilterOutlined, SwapOutlined, ArrowUpOutlined, ArrowDownOutlined, ExperimentOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight, faDownload, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import Helpers from '@Apis/helpers';
import constants, { QUANTITY, INFINITE_EXPIRY_DATE, DEFAULT_CUR_ROUND_OFF } from '@Apis/constants';
import SelectDepartment from '@Components/Common/SelectDepartment';
import H3Text from '@Uilib/h3Text';
import searchIcon from '@Images/icons/icon-search.png';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import InventoryLocationActions from '@Actions/settings/inventoryLocationActions';
import StockMasterActions from '@Actions/inventory/stockMasterActions';
import TenantActions from '@Actions/tenantActions';
import H3DateSelector from '@Uilib/h3DateSelector';
import BatchActions from '@Actions/batchActions';
import QualityCheckActions from '@Actions/quality/qualityCheckActions';
import CategoryActions from '@Actions/categoryActions';
import ReservationActions from '@Actions/reservationActions';
import CategoryFilterNew from '../../../Common/CategoryFilterNew';
import AnalyticsActions from '../../../../actions/application/analyticsActions';
import HideValue from '../../../Common/RestrictedAccess/HideValue';
import ViewBatchCustomFields from '../../../Common/ViewBatchCustomFields';
import PRZText from '../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import ListScreenKeys from './mobileListHelper';
import PRZSelect from '../../../Common/UI/PRZSelect';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import { dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums } from '../../../../apis/constants';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';
import './style.scss';

const { Option } = Select;

function BatchReservations({
  history, user, org, getBatchesDataLoading, getReservations, getReservationsLoading, getBatchesLoading, getBatches,
  inventoryLocations, getInventoryLocationsLoading, getInventoryLocations, departments, retestQualityCheck,
  getCategories, MONEY, subCategories, reservations, selectedSkuProduct, match, expiryDays, updateFreeReservation, updateFreeReservationLoading, isViewProduct, priceMasking,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [availableStocks, setAvailableStocks] = useState('POSITIVE_QUANTITY_BATCHES');
  const [expiryStartDate, setExpiryStartDate] = useState('');
  const [expiryEndDate, setExpiryEndDate] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [sortOrder, setSortOrder] = useState('ASC');
  const [isExpired, setIsExpired] = useState('');
  const [sortOrderByExpiryDate, setSortOrderByExpiryDate] = useState('');
  const [sortOrderByProductName, setSortOrderByProductName] = useState('');
  const [selectedFilterTenantDepartment, setSelectedFilterTenantDepartment] = useState('');
  const [selectedTenantDepartment, setSelectedTenantDepartment] = useState('');
  const [selectedFilterInventoryLocation, setSelectedFilterInventoryLocation] = useState('');
  const [selectedFilterInventoryLocationName, setSelectedFilterInventoryLocationName] = useState('');
  const [isRejectedBatch, setIsRejectedBatch] = useState('');
  const [expiryStatus, setExpiryStatus] = useState('');
  const [open, setOpen] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [call, setCall] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-reservations') ? JSON.parse(localStorage.getItem('prcz-page-columns-reservations')) : {
    PRODUCT: {
      label: 'Product',
      visible: true,
      hidden: false,
    },
    BUSINESS_UNIT: {
      label: 'Business Unit',
      visible: true,
      hidden: false,
    },
    BATCH_NUMBER: {
      label: 'Batch #',
      visible: true,
      hidden: false,
    },
    LOT_NUMBER: {
      label: 'Lot #',
      visible: true,
      hidden: true,
    },
    COST_PRICE: {
      label: 'Cost Price',
      visible: true,
      hidden: false,
    },
    LANDED_COST: {
      label: 'Landed Cost',
      visible: true,
      hidden: true,
    },
    SELLING_PRICE: {
      label: 'Selling Price',
      visible: true,
      hidden: true,
    },
    LOCATION: {
      label: 'Location',
      visible: true,
      hidden: false,
    },
    EXPIRY_DATE: {
      label: 'Expiry',
      visible: true,
      hidden: false,
    },
    ON_HAND_STOCK: {
      label: 'On Hand Stock',
      visible: true,
      hidden: false,
    },
    RESERVED_STOCK: {
      label: 'Reserved Stock',
      visible: true,
      hidden: false,
    },
    MANUFACTURING_DATE: {
      label: 'Manufacturing Date',
      visible: false,
      hidden: true,
    },

  });
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);
  const fixedColumns = ['PRODUCT'];

  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const [batchDateSelectedIntervalDateRangeType, setBatchDateSelectedIntervalDateRangeType] = useState('');
  const [expiryDateSelectedIntervalDateRangeType, setExpiryDateSelectedIntervalDateRangeType] = useState('');

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const [selectedInterval, setSelectedInterval] = useState('');
  const reservationsData = () => reservations?.reservations?.map((item) => ({
    ...item,
    key: item?.reservation_id,
  }));

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const batchesColumns = () => {
    const columns = [
      {
        title: '',
        render: (record) => {
          const expiryMoment = dayjs(dayjs(record.expiry_date).format('YYYY-MM-DD'));
          let shelfLife = 0;
          if (dayjs().isSameOrBefore(expiryMoment)) {
            shelfLife = expiryMoment.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days');
          }
          // eslint-disable-next-line prefer-const
          let shelfLifePct = Math.round(((shelfLife / record.expiry_days) * 100));
          return (
            <div className="mobile-list__card">
              <div className="mobile-list__card_header">
                <div className="mobile-list__card_header-left">
                  <PRZText className="mobile-list__card_item-number" text={`#${record?.custom_batch_number ? record.custom_batch_number : record?.batch_number}`} />
                </div>

              </div>
              <div className="mobile-list__card_body">
                <div className="mobile-list__card_body-left">
                  <Link>
                    <PRZText
                      text={`#${record?.internal_sku_code}`}
                      className="mobile-list__card_item-number"
                    />
                  </Link>
                  {record?.product_sku_name && (
                    <div className="mobile-list__card_item-name_wrapper">
                      <Link>
                        <PRZText
                          className="mobile-list__card_item-name"
                          text={record?.product_sku_name}
                        />
                      </Link>
                    </div>
                  )}

                  <PRZText
                    text={`Location - ${record?.tenant_name} (${record?.department_name})`}
                    className="mobile-list__card_item-details"
                  />

                  <Link>
                    <PRZText
                      text={record?.reservation_entity_number || '-'}
                      className="mobile-list__card_item-details"
                    />
                  </Link>

                </div>
                <div className="mobile-list__card_body-right">
                  {record?.product_type?.toUpperCase() !== 'SERVICE' && (
                    <Tooltip
                      color="white"
                      placement="top"
                      title={(
                        <PRZText className="mobile-list__card_item__tooltip_text-color" text="Available Stock" />
                      )}
                    >
                      <PRZText
                        text={`${QUANTITY(record?.reserved_qty - record?.consumed_qty, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`}
                        className="mobile-list__card_item-details"
                      />
                    </Tooltip>
                  )}
                </div>
              </div>

              <Divider className="mobile-list__card_divider" />

              <div className="mobile-list__card_footer">
                <div className="mobile-list__card_footer-left">
                  {shelfLife !== 0 ? (
                    <div>
                      {record?.expiry_date === '2099-01-01'
                        && <Tag color="green">No expiry</Tag>}
                    </div>
                  ) : (
                    <div className="inventory-lookup__expired-row">
                      Expired on&nbsp;
                      {dayjs(record?.expiry_date).format('DD/MMM/YYYY')}
                    </div>
                  )}
                </div>
                <div className="mobile-list__card_footer-right">
                  <PRZText
                    className="mobile-list__card__view-more_wrapper"
                    onClick={() => {
                      setSelectedBatch(record);
                      setMoreDetailsDrawer(true);
                    }}
                    text={(
                      <span className="mobile-list__card__view-more-text_wrapper">
                        <span className="mobile-list__card__view-more-text">More Info</span>
                        <FontAwesomeIcon
                          className="mobile-list__card__view-more-icon"
                          icon={faAnglesRight}
                        />
                      </span>
                    )}
                  />
                </div>
              </div>
            </div>
          );
        },
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'PRODUCT',
        render: (record) => (
          <div className="min-width-70">
            <div className="associated-entity">
              <Link to={`/inventory/product/view/${record?.product_sku_id}`} target="_blank">
                {`#${record?.internal_sku_code}`}
              </Link>
            </div>
            <div>{`${record?.ref_product_code ? `${record?.ref_product_code} - ` : ''}${record?.product_sku_name}`}</div>
          </div>
        ),
        fixed: 'left',
        className: !visibleColumns?.PRODUCT?.visible ? 'display-none' : '',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'LOCATION',
        render: (record) => (
          <div className="min-width-70">
            {record?.tenant_name}
            <H3Text text={record?.department_name} className="table-subscript" />
          </div>
        ),
        className: !visibleColumns?.BUSINESS_UNIT?.visible ? 'display-none' : '',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'BATCH #',
        editable: true,
        render: (record) => (
          <div className="column-number__wrapper min-width-70">
            {record?.custom_batch_number ? record.custom_batch_number : record?.batch_number}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.BATCH_NUMBER?.visible ? 'display-none' : '',
      },
      {
        title: 'OH HAND',
        render: (record) => <div className="min-width-70">{`${QUANTITY(record?.available_qty, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`}</div>,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ON_HAND_STOCK?.visible ? 'display-none' : '',
      },
      {
        title: 'RESERVED',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => <div className="min-width-85">{`${QUANTITY(record?.reserved_qty - record?.consumed_qty, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`}</div>,
        className: !visibleColumns?.RESERVED_STOCK?.visible ? 'display-none' : '',
      },
      {
        title: 'ORDER',
        editable: true,
        render: (record) => (
          <div className="associated-entity min-width-50">
            <Link to={`${record?.reservation_entity_name === 'MANUFACTURING_ORDER' ? '/production/manufacturing-orders/view' : '/sales/sales-order/view'}/${record?.reservation_entity_id}`}>
              {record?.reservation_entity_number || '-'}
            </Link>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LOT_NUMBER?.visible ? 'display-none' : '',
      },
      {
        title: 'EXPIRY',
        render: (record) => {
          const expiryMoment = dayjs(dayjs(record.expiry_date).format('YYYY-MM-DD'));
          let shelfLife = 0;
          if (dayjs().isSameOrBefore(expiryMoment)) {
            shelfLife = expiryMoment.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days');
          }
          // eslint-disable-next-line prefer-const
          let shelfLifePct = Math.round(((shelfLife / record.expiry_days) * 100));

          return (
            <div className="min-width-70">
              {
                shelfLife !== 0 ? (
                  <div>
                    <div>
                      {record?.expiry_date === '2099-01-01'
                        ? <Tag color="green">No expiry</Tag> : (
                          <div className="product-batch-shelf-life">
                            <div
                              className="progress-line__wrapper"
                              style={{
                                width: '80px',
                                backgroundColor: shelfLifePct < 25 ? 'rgba(216,51,15,0.2)' : shelfLifePct > 75 ? 'rgba(23,181,77,0.2)' : 'rgba(204,185,10,0.2)',
                              }}
                            >
                              <div
                                className="progress-line"
                                style={{
                                  width: `${shelfLifePct > 100 ? 100 : shelfLifePct}%`,
                                  backgroundColor: shelfLifePct < 25 ? '#D8330F' : shelfLifePct > 75 ? '#17B54D' : '#CCB90A',
                                }}
                              />
                            </div>
                            <span>
                              {`${shelfLife} Days (${shelfLifePct > 100 ? 100 : shelfLifePct}%)`}
                            </span>
                          </div>
                        )}
                    </div>
                  </div>
                ) : (
                  <div className="inventory-lookup__expired-row">
                    Expired on&nbsp;
                    {dayjs(record?.expiry_date).format('DD/MMM/YYYY')}
                  </div>
                )
              }
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.EXPIRY_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'COST PRICE',
        editable: true,
        render: (record) => (
          <div className="column-amount min-width-100">
            {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view cost price" /> : MONEY(record?.cost_price)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.COST_PRICE?.visible ? 'display-none' : '',
      },
      {
        title: 'LANDED COST',
        editable: true,
        render: (record) => (
          <div className="column-amount min-width-115">
            {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view landed cost" /> : MONEY(record?.landed_cost)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LANDED_COST?.visible ? 'display-none' : '',
      },
      {
        title: 'SELLING PRICE',
        editable: true,
        render: (record) => (
          <div className="column-amount min-width-115">
            {(isDataMaskingPolicyEnable && isHideSellingPrice)
              ? <HideValue showPopOver popOverMessage="You don't have access to view selling price" /> : MONEY(record?.selling_price)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.SELLING_PRICE?.visible ? 'display-none' : '',
      },
      {
        title: 'MFG DATE',
        editable: true,
        render: (record) => (
          <div className="column-date min-width-70">
            {record?.manufacturing_date ? dayjs(record?.manufacturing_date).format('DD/MM/YYYY') : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.MANUFACTURING_DATE?.visible ? 'display-none' : '',
      },
    ];
    return columns.filter((item) => !item.hidden);
  };

  const getColumns = () => {
    const enabledWarehouseLocations = user?.tenant_info?.inventory_config?.settings?.enable_location_based_stock;
    const batchColumns = [
      {
        title: 'Department',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        // dataIndex: 'department_name',
        render: (record) => (
          <div className="min-width-85">
            {record?.department_name}
          </div>
        ),
      },
      {
        title: 'Batch#',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => {
          const batchConfig = org?.organisation?.[0]?.inventory_config?.settings?.batch_management;
          return (
            <div className="min-width-70">
              <H3Text text={record?.custom_batch_number || record?.batch_number} className="column__batch-number" />
              <div className="table-subscript">
                {record?.lot_number && batchConfig?.lot_number_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span className="batch-details__label">Lot#</span>
                      {' '}
                      {record?.lot_number}
                    </span>
                  )}
                  />
                )}
                {record?.ar_number && batchConfig?.ar_number_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span className="batch-details__label">AR#</span>
                      {' '}
                      {record?.ar_number}
                    </span>
                  )}
                  />
                )}
                {record?.batch_barcode && batchConfig?.batch_barcode_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span className="batch-details__label">Barcode</span>
                      {' '}
                      {record?.batch_barcode}
                    </span>
                  )}
                  />
                )}
                {record?.batch_inward_date && batchConfig?.batch_inward_date_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span className="batch-details__label">Inward Date</span>
                      {' '}
                      <div className="column-date">
                        {dayjs(record?.batch_inward_date).format('DD MMM, YY')}
                      </div>
                    </span>
                  )}
                  />
                )}
                {record?.roll_no && batchConfig?.roll_no_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span className="batch-details__label">Roll No#</span>
                      {' '}
                      {record?.roll_no}
                    </span>
                  )}
                  />
                )}
                {record?.brand && batchConfig?.brand_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span className="batch-details__label">Brand</span>
                      {' '}
                      {record?.brand}
                    </span>
                  )}
                  />
                )}
                {record?.mfg_batch_no && batchConfig?.mfg_batch_no_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span className="batch-details__label">Mfg batch #</span>
                      {' '}
                      {record?.mfg_batch_no}
                    </span>
                  )}
                  />
                )}
                {record?.manufacturing_date && batchConfig?.manufacturing_date_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span className="batch-details__label">Mfg Date</span>
                      {' '}
                      <div className="column-date">
                        {Helpers.batchDateFormatter(record?.manufacturing_date, selectedSkuProduct?.manufacturing_date_format)}
                      </div>
                    </span>
                  )}
                  />
                )}
                {record?.next_qc_date && batchConfig?.next_qc_date_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span className="batch-details__label">Next QC Date</span>
                      {' '}
                      <div>
                        {dayjs(record?.next_qc_date).format('DD MMM, YY')}
                      </div>
                    </span>
                  )}
                  />
                )}
                {record?.last_qc_date && batchConfig?.last_qc_date_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span className="batch-details__label">Last QC Date</span>
                      {' '}
                      <div>
                        {dayjs(record?.last_qc_date).format('DD MMM, YY')}
                      </div>
                    </span>
                  )}
                  />
                )}
              </div>
            </div>
          );
        },
      },
      {
        title: 'Shelf Life',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => {
          const expiryMoment = dayjs(dayjs(record.expiry_date).format('YYYY-MM-DD'));
          let shelfLife = 0;
          if (dayjs().isSameOrBefore(expiryMoment)) {
            shelfLife = expiryMoment.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days');
          }
          let shelfLifePct = Math.round(((shelfLife / expiryDays) * 100));
          if (record?.expiry_date === INFINITE_EXPIRY_DATE) shelfLifePct = 100;
          if (expiryDays < 0) {
            return (
              <div style={{ width: '160px' }}>
                No Expiry (100%)
              </div>
            );
          }
          return (
            (
              <div className="100">
                <div className="product-batch-shelf-life">
                  <div
                    className="progress-line__wrapper"
                    style={{
                      width: '80px',
                      backgroundColor: shelfLifePct < 25 ? 'rgba(216,51,15,0.2)' : shelfLifePct > 75 ? 'rgba(23,181,77,0.2)' : 'rgba(204,185,10,0.2)',
                    }}
                  >
                    <div
                      className="progress-line"
                      style={{
                        width: `${shelfLifePct > 100 ? 100 : shelfLifePct}%`,
                        backgroundColor: shelfLifePct < 25 ? '#D8330F' : shelfLifePct > 75 ? '#17B54D' : '#CCB90A',
                      }}
                    />
                  </div>
                  <span>
                    {record?.expiry_date === INFINITE_EXPIRY_DATE ? 'NA' : `${shelfLife} Days (${shelfLifePct > 100 ? 100 : shelfLifePct}%)`}
                  </span>
                </div>
                {record?.expiry_date !== INFINITE_EXPIRY_DATE ? (
                  <div className="colummn-date">
                    {`Expires on ${Helpers.batchDateFormatter(record?.expiry_date, selectedSkuProduct?.expiry_date_format)}`}
                  </div>
                ) : ''}
              </div>
            )
          );
        },
      },
      {
        title: 'Vendor',
        render: (text, record) => (
          <div className="associated-entity min-width-70">
            {record?.seller_id ? (
              <Link to={`/vendors/view/${record?.seller_id}`} target="_blank">
                {record?.seller_name}
              </Link>
            ) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'Costing',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => {
          const batchConfig = org?.organisation?.[0]?.inventory_config?.settings?.batch_management;
          return (
            <div className="table-subscript min-width-85">
              {record?.mrp > 0 && batchConfig?.mrp_is_enabled && (
                <H3Text text={(
                  <div className="batch-details__wrapper">
                    <div className="batch-details__label">MRP</div>
                    <div className="column-amount">
                      {MONEY(record?.mrp)}
                    </div>
                  </div>
                )}
                />
              )}
              {record?.cost_price > 0 && batchConfig?.cost_price_is_enabled && (
                <H3Text text={(
                  <div className="batch-details__wrapper">
                    <div className="batch-details__label">Cost Price</div>
                    <div className="column-amount">
                      {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view cost price" /> : MONEY(record?.cost_price)}
                    </div>
                  </div>
                )}
                />
              )}
              {record?.freight_cost > 0 && batchConfig?.freight_cost_is_enabled && (
                <H3Text text={(
                  <div className="batch-details__wrapper">
                    <div className="batch-details__label">Freight Cost</div>
                    <div className="column-amount">
                      {MONEY(record?.freight_cost)}
                    </div>
                  </div>
                )}
                />
              )}
              {record?.other_cost > 0 && batchConfig?.other_cost_is_enabled && (
                <H3Text text={(
                  <div className="batch-details__wrapper">
                    <div className="batch-details__label">Other Cost</div>
                    <div className="column-amount">
                      {MONEY(record?.other_cost)}
                    </div>
                  </div>
                )}
                />
              )}
              {record?.landed_cost > 0 && batchConfig?.landed_cost_is_enabled && (
                <H3Text text={(
                  <div className="batch-details__wrapper">
                    <div className="batch-details__label">Landed Cost</div>
                    <div className="column-amount">
                      {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view landed cost" /> : MONEY(record?.landed_cost)}
                    </div>
                  </div>
                )}
                />
              )}
              {record?.selling_price > 0 && batchConfig?.selling_price_is_enabled && (
                <H3Text text={(
                  <div className="batch-details__wrapper">
                    <div className="batch-details__label">Selling Price</div>
                    <div className="column-amount">
                      {(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view selling price" /> : MONEY(record?.selling_price)}
                    </div>
                  </div>
                )}
                />
              )}
              {record?.margin > 0 && batchConfig?.margin_is_enabled && (
                <H3Text text={(
                  <div className="batch-details__wrapper">
                    <div className="batch-details__label">Margin</div>
                    <div>
                      {parseFloat(Number(record?.margin).toFixed(DEFAULT_CUR_ROUND_OFF))}
                      %
                    </div>
                  </div>
                )}
                />
              )}
            </div>
          );
        },
      },
      {
        title: 'Custom Fields',
        render: (record) => <div className="min-width-150"><ViewBatchCustomFields customFields={record?.custom_fields} /></div>,
        responsive: ['sm', 'md', 'lg', 'xxl'],
        // hidden: false,
        hidden: isMobile,
      },
      {
        title: 'Reserved qty',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-100">
            <H3Text className={`product-batch-available-txn-stock ${record?.reserved_qty <= 0 ? 'product-batch-available-txn-stock-negative' : ''}`} text={`${record?.reserved_qty > 0 ? '+' : ''}${QUANTITY(record?.reserved_qty || '0', selectedSkuProduct?.uom_info?.precision)} ${selectedSkuProduct?.uom_info?.uqc?.toProperCase()}`} />
            <Link
              to={`${record?.reservation_entity_name === 'SALES_ORDER' ? '/sales/sales-order/view/' : '/production/manufacturing-orders/view/'}${record?.reservation_entity_id}`}
              className="table-subscript"
            >
              {record?.reservation_entity_number}
            </Link>
          </div>
        ),
      },
      {
        title: 'Consumed qty',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-100">
            <H3Text className={`product-batch-available-txn-stock ${record?.consumed_qty <= 0 ? 'product-batch-available-txn-stock-negative' : ''}`} text={`${record?.consumed_qty > 0 ? '+' : ''}${QUANTITY(record?.consumed_qty || '0', selectedSkuProduct?.uom_info?.precision)} ${selectedSkuProduct?.uom_info?.uqc?.toProperCase()}`} />
          </div>
        ),
      },
      {
        title: 'Available qty',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-115">
            <H3Text className={`product-batch-available-txn-stock ${(record?.reserved_qty - record?.consumed_qty) <= 0 ? 'product-batch-available-txn-stock-negative' : ''}`} text={`${(record?.reserved_qty - record?.consumed_qty) > 0 ? '+' : ''}${QUANTITY((record?.reserved_qty - record?.consumed_qty) || '0', selectedSkuProduct?.uom_info?.precision)} ${selectedSkuProduct?.uom_info?.uqc?.toProperCase()}`} />
          </div>
        ),
      },
    ];
    if (batchColumns?.length) {
      if (enabledWarehouseLocations) {
        batchColumns.push({
          title: 'Location',
          render: (text, record) => (
            <div className="min-width-70">
              {record?.inventory_location_path || '-'}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
        });
      }
      batchColumns.push({
        title: 'Quality',
        render: (text, record) => (
          <div className="qr__status min-width-70" style={{ backgroundColor: !record?.is_rejected_batch ? '#2fbc6e' : 'red' }}>
            {!record?.is_rejected_batch ? 'Good' : 'Bad'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        fixed: 'right',
      });
      batchColumns.push({
        title: '',
        className: 'list__actions-column',
        dataIndex: 'operation',
        fixed: 'right',
        render: (_, record) => (
          record?.batch_id ? (
            <div className="list__actions">
              {record?.mo_adjustment_id && (dayjs(dayjs(record.created_at).format('YYYY-MM-DD')).isAfter('2024-01-01', 'day')) && (
                <div
                  className="batch-bmr-button"
                  onClick={() => downloadDocument({
                    url: `${constants.MO}/bmr_report?mo_adjustment_id=${record?.mo_adjustment_id}`,
                    document_type: 'BATCH_MANUFACTURING_RECORD',
                    document_number: record?.batch_number,
                    key: uuidv4(),
                  })}
                >
                  <H3Text
                    text={(
                      <Fragment>
                        <FontAwesomeIcon
                          icon={faDownload}
                          className="action-button-text"
                        />
                        &nbsp; BMR
                      </Fragment>
                    )}
                    className="list__actions-button"
                  />
                </div>
              )}
              {/* {user?.tenant_info?.quality_control_config && Helpers.getPermission(Helpers.permissionEntities.QUALITY_CHECKS,
                  Helpers.permissionTypes.CREATE, user) && (
                    <Popconfirm
                      title="Send this batch for quality retest?"
                      disabled={!record?.is_available_for_retest}
                      onConfirm={() => {
                        retestQualityCheck({ batch_ids: [record.batch_id], loadingHandler: getBatchesLoading }, () => {
                          setCall(!call);
                        });
                      }}
                    >
                      <div className="list__actions-button">
                        <ExperimentOutlined style={{ color: !record?.is_available_for_retest ? '#d3d3d3' : '#2d7cf7' }} />
                      </div>
                    </Popconfirm>
                  )} */}
            </div>
          ) : null
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      });
    }
    return batchColumns.filter((item) => !item.hidden);
  };

  const getBatchesColumn = () => {
    if (selectedSkuProduct) {
      return getColumns();
    }
    return batchesColumns();
  };

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit')) || limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'org_id',
        filter_value: user?.tenant_info?.org_id,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'isExpired',
        filter_value: Boolean(Helpers.getValueFromUrl('isExpired')) || '',
        filter_type: filterTypeEnums.BOOLEAN,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant')
          ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => Number(item))
          : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'department_id',
        filter_value: Number(Helpers.getValueFromUrl('department_id')) || null,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'quantity_class',
        filter_value: Helpers.getValueFromUrl('quantity_class') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'expiry_status',
        filter_value: Helpers.getValueFromUrl('expiry_status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'categories',
        filter_value:
          Helpers.getValueFromUrl('categories') && Helpers.getValueFromUrl('categories') !== 'null'
            ? Helpers.getValueFromUrl('categories')?.split(',')?.filter(Boolean)?.map(Number)
            : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'startDate',
        filter_value: Number(Helpers.getValueFromUrl('startDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('batch_date_type') || '',
      },
      {
        filter_key: 'endDate',
        filter_value: Number(Helpers.getValueFromUrl('endDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('batch_date_type') || '',
      },
      {
        filter_key: 'sortOrderByProductName',
        filter_value: Helpers.getValueFromUrl('sortOrderByProductName') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'sortOrderByExpiryDate',
        filter_value: Helpers.getValueFromUrl('sortOrderByExpiryDate') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'expiryStartDate',
        filter_value: Number(Helpers.getValueFromUrl('expiryStartDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('expiry_date_type') || '',
      },
      {
        filter_key: 'expiryEndDate',
        filter_value: Number(Helpers.getValueFromUrl('expiryEndDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('expiry_date_type') || '',
      },
      {
        filter_key: 'isRejectedBatch',
        filter_value:
          Helpers.getValueFromUrl('isRejectedBatch') === ''
            ? ''
            : Helpers.getValueFromUrl('isRejectedBatch') === 'true'
              ? true
              : Helpers.getValueFromUrl('isRejectedBatch') === 'false'
                ? false
                : '',
        filter_type: filterTypeEnums.BOOLEAN,
      },
      {
        filter_key: 'sortOrderByBatch',
        filter_value: Helpers.getValueFromUrl('sortOrderByBatch') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'inventory_location_id',
        filter_value: Number(Helpers.getValueFromUrl('inventory_location_id')) || '',
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'sortOrder',
        filter_value: Helpers.getValueFromUrl('sortOrder') || 'ASC',
        filter_type: filterTypeEnums.STRING,
      },
    ];

    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => {
    const initialFilters = [{
      filter_key: 'limit',
      filter_value: limit,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'org_id',
      filter_value: user?.tenant_info?.org_id,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'keyword',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'isExpired',
      filter_value: '',
      filter_type: filterTypeEnums.BOOLEAN,
    },
    {
      filter_key: 'tenant',
      filter_value: [user?.tenant_info?.tenant_id],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'department_id',
      filter_value: Number(Helpers.getDepartmentId(user)) || Number(user?.tenant_info?.department_id),
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'quantity_class',
      filter_value: 'POSITIVE_QUANTITY_BATCHES',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'expiry_status',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'categories',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'startDate',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'endDate',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'sortOrderByProductName',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'sortOrderByExpiryDate',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'expiryStartDate',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'expiryEndDate',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'isRejectedBatch',
      filter_value: '',
      filter_type: filterTypeEnums.BOOLEAN,
    },
    {
      filter_key: 'sortOrderByBatch',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'inventory_location_id',
      filter_value: '',
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'sortOrder',
      filter_value: 'ASC',
      filter_type: filterTypeEnums.STRING,
    },
    ];

    return initialFilters;
  }, []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.BATCH_RESERVATION,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      setVisibleColumns(columns);
      setSelectedFilterView(systemDefaultUserView);

      // setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      // setLimit(Helpers.getValueFromUrl('limit') || limit);
      // setSearchKeyword(Helpers.getValueFromUrl('keyword'));
      // setAvailableStocks(Helpers.getValueFromUrl('quantity_class') || 'POSITIVE_QUANTITY_BATCHES');
      // setIsExpired(Helpers.getValueFromUrl('isExpired'));
      // setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (Number(item))) : [user?.tenant_info?.tenant_id]);
      // setSelectedDepartment(Helpers.getDepartmentId(user) || user?.tenant_info?.department_id);
      // setExpiryStatus(Helpers.getValueFromUrl('expiry_status') || '');
      // setSelectedCategory(Helpers.getValueFromUrl('category')?.split(',')?.filter(Boolean)?.map(Number) || []);
      // setStartDate(Number(Helpers.getValueFromUrl('startDate')));
      // setEndDate(Number(Helpers.getValueFromUrl('endDate')));
      // setSortOrderByProductName(Helpers.getValueFromUrl('sortOrderByProductName'));
      // setSortOrderByExpiryDate(Helpers.getValueFromUrl('sortOrderByExpiryDate'));
      // setExpiryStartDate(Number(Helpers.getValueFromUrl('expiryStartDate')));
      // setExpiryEndDate(Number(Helpers.getValueFromUrl('expiryEndDate')));
      // let isRejectedBatchValuetemp = '';
      // const isRejectedBatchValue = Helpers.getValueFromUrl('isRejectedBatch');
      // if (isRejectedBatchValue === '') {
      //   isRejectedBatchValuetemp = '';
      // } else if (isRejectedBatchValue === 'true') {
      //   isRejectedBatchValuetemp = true;
      // } else if (isRejectedBatchValue === 'false') {
      //   isRejectedBatchValuetemp = false;
      // }
      // setIsRejectedBatch(isRejectedBatchValuetemp);
      // setIsUserReady(true);
    }
  }, []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _batchDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

        let _batchStartDate = '';
        let _batchEndDate = '';

        if (_batchDateRangeType === '' || _batchDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_batchDateRangeType);
          const [start, end] = date;

          _batchStartDate = start;
          _batchEndDate = end;
          filterValue.startDate = _batchStartDate;
          filterValue.endDate = _batchEndDate;
        }

        filterValue.batchDateRangeType = _batchDateRangeType;

        const _expiryDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'expiryStartDate', valueOnly: false }).date_range_type;

        let _expiryStartDate = '';
        let _expiryEndDate = '';

        if (_expiryDateRangeType === '' || _expiryDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_expiryDateRangeType);
          const [start, end] = date;

          _expiryStartDate = start;
          _expiryEndDate = end;
          filterValue.expiryStartDate = _expiryStartDate;
          filterValue.expiryEndDate = _expiryEndDate;
        }
        filterValue.expiryDateRangeType = _expiryDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);

      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setAvailableStocks(tempFilterValues.quantity_class);
        setIsExpired(tempFilterValues.isExpired);
        setSelectedTenant(tempFilterValues.tenant);
        setSelectedDepartment(tempFilterValues.department_id);
        setExpiryStatus(tempFilterValues.expiry_status);
        setSelectedCategory(tempFilterValues.categories);
        setStartDate(tempFilterValues.startDate);
        setEndDate(tempFilterValues.endDate);
        setBatchDateSelectedIntervalDateRangeType(tempFilterValues.batchDateRangeType);
        setSortOrderByProductName(tempFilterValues.sortOrderByProductName);
        setSortOrderByExpiryDate(tempFilterValues.sortOrderByExpiryDate);
        setExpiryStartDate(tempFilterValues.expiryStartDate);
        setExpiryEndDate(tempFilterValues.expiryEndDate);
        setExpiryDateSelectedIntervalDateRangeType(tempFilterValues.expiryDateRangeType);
        setIsRejectedBatch(tempFilterValues.isRejectedBatch);
        setSelectedFilterInventoryLocation(tempFilterValues.inventory_location_id);
        setSortOrder(tempFilterValues.sortOrder || 'ASC');
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  const pushParamsToUrl = (page, lim, orgId, currentTenant, order, exp, word, startDateEpoch, endDateEpoch, department, expiryStartDateEpoch, expiryEndDateEpoch, sortOrderbypdtname, sortOrderbyexpdate, sortOrderbybatchname, inventoryLocation, rej, category, expiryStatus, availableStock, batchDateSelectedIntervalDateRangeType, expiryDateSelectedIntervalDateRangeType, selectedFilterView) => {
    let url = '?tab=/batch-reservations';
    if (page) url += `&page=${page}`;
    if (lim) url += `&limit=${lim}`;
    if (orgId) url += `&org_id=${orgId}`;
    if (word) url += `&keyword=${word}`;
    if (currentTenant) url += `&tenant=${currentTenant}`;
    if (department) url += `&department_id=${department}`;
    if (order) url += `&sortOrder=${order}`;
    if (sortOrderbypdtname) url += `&sortOrderByProductName=${sortOrderbypdtname}`;
    if (sortOrderbyexpdate) url += `&sortOrderByExpiryDate=${sortOrderbyexpdate}`;
    if (sortOrderbybatchname) url += `&sortOrderByBatch=${sortOrderbybatchname}`;
    if (exp) url += `&isExpired=${exp}`;
    if (startDateEpoch) url += `&startDate=${startDateEpoch}`;
    if (endDateEpoch) url += `&endDate=${endDateEpoch}`;
    // if (expTimeRange) url += `&exp_time_range=${expTimeRange}`;
    if (expiryStartDateEpoch) url += `&expiryStartDate=${expiryStartDateEpoch}`;
    if (expiryEndDateEpoch) url += `&expiryEndDate=${expiryEndDateEpoch}`;
    if (inventoryLocation) url += `&inventory_location_id=${inventoryLocation}`;
    if (rej === true || rej === false) url += `&isRejectedBatch=${rej}`;
    if (category) url += `&categories=${category}`;
    if (expiryStatus) url += `&expiry_status=${expiryStatus}`;
    if (availableStock) url += `&quantity_class=${availableStock}`;
    if (batchDateSelectedIntervalDateRangeType) url += `&batch_date_type=${batchDateSelectedIntervalDateRangeType}`;
    if (expiryDateSelectedIntervalDateRangeType) url += `&expiry_date_type=${expiryDateSelectedIntervalDateRangeType}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView.filter_id}`;
    history.push(url);
  };

  useEffect(() => {
    if (isUserReady) {
      if (!selectedSkuProduct) {
        pushParamsToUrl(currentPage, limit, user?.tenant_info?.org_id, selectedTenant, sortOrder, isExpired, searchKeyword, startDate, endDate, selectedDepartment, expiryStartDate, expiryEndDate, sortOrderByProductName, sortOrderByExpiryDate, '', selectedFilterInventoryLocation, isRejectedBatch, selectedCategory, expiryStatus, availableStocks, batchDateSelectedIntervalDateRangeType, expiryDateSelectedIntervalDateRangeType, selectedFilterView);
        getInventoryLocations(selectedFilterTenantDepartment || '', '', null, true, Helpers.getValueFromUrl('tenant') || user?.tenant_info?.tenant_id, selectedDepartment?.toString() || Helpers.getValueFromUrl('department_id')?.toString());
      }
      getCategories();
      let isRejectedBatchValuetemp = '';
      const isRejectedBatchValue = Helpers.getValueFromUrl('isRejectedBatch');
      if (isRejectedBatchValue === '') {
        isRejectedBatchValuetemp = '';
      } else if (isRejectedBatchValue === 'true') {
        isRejectedBatchValuetemp = true;
      } else if (isRejectedBatchValue === 'false') {
        isRejectedBatchValuetemp = false;
      }
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());

      const payload = {
        filters: {
          org_id: user?.tenant_info?.org_id,
          expiry_status: expiryStatus || Helpers.getValueFromUrl('expiry_status'),
          is_rejected_batch: isRejectedBatch || isRejectedBatchValuetemp,
          inventory_location_id: selectedFilterInventoryLocation || Helpers.getValueFromUrl('inventory_location_id'),
          expiry_date_from_date: expiryStartDate || Helpers.getValueFromUrl('expiryStartDate'),
          expiry_date_to_date: expiryEndDate || Helpers.getValueFromUrl('expiryEndDate'),
          product_category_ids: selectedCategory.join(','),
          tenant_ids: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PRODUCT, Helpers.permissionTypes.READ)?.join(','),
          created_date_from: startDate || Helpers.getValueFromUrl('startDate'),
          created_date_to: endDate || Helpers.getValueFromUrl('endDate'),
          search: searchKeyword || Helpers.getValueFromUrl('keyword'),
          quantity_class: availableStocks || Helpers.getValueFromUrl('availableStocks'),
          department_id: selectedDepartment || Helpers.getValueFromUrl('department_id'),
          is_expired: isExpired || Helpers.getValueFromUrl('isExpired'),
          product_sku_id: selectedSkuProduct ? match.params.productSkuId : null,
        },
        order_bys: {
          order_by_product_name: sortOrderByProductName || Helpers.getValueFromUrl('sortOrderByProductName'),
          order_by_expiry_date: sortOrderByExpiryDate || Helpers.getValueFromUrl('sortOrderByExpiryDate'),
        },
        sort_order: sortOrder || Helpers.getValueFromUrl('sortOrder'), // ASC OR DESC
        page: currentPage || Helpers.getValueFromUrl('page'),
        limit: limit || Helpers.getValueFromUrl('limit'),

      };
      getReservations(payload);
    }
  }, [currentPage, limit, user?.tenant_info?.org_id, selectedTenant, startDate, endDate, selectedDepartment, expiryStartDate, expiryEndDate, sortOrder, isExpired, sortOrderByProductName, sortOrderByExpiryDate, '', selectedTenantDepartment, selectedFilterInventoryLocation, isRejectedBatch, selectedCategory, expiryStatus, call, availableStocks, batchDateSelectedIntervalDateRangeType, expiryDateSelectedIntervalDateRangeType,
    // selectedFilterView
  ]);

  const findCategoryNameById = (categories, id) => {
    if (!categories) return null; // Ensure categories is not undefined
    for (const category of categories) {
      if (category.product_category_id === id) {
        return category.product_category_name;
      }
      if (category.sub_categories) {
        const subCategoryName = findCategoryNameById(category.sub_categories, id);
        if (subCategoryName) {
          return subCategoryName;
        }
      }
    }
    return null; // Return null if no matching category is found
  };

  const handleClearResrevation = () => {
    const payload = selectedRowKeys?.map((item) => ({ reservation_id: item }));

    updateFreeReservation(payload, () => {
      setSelectedRowKeys([]);
      setCall(!call);
    });
  };

  const batchStatusOptions = [
    { key: 0, value: '', label: 'All Batches' },
    { key: 1, value: 'Expired', label: 'Expired' },
    {
      key: 2,
      value: 'Near Expiry',
      label: 'Near Expiry (<25% Shelf Life)',
    },
    {
      key: 3,
      value: 'Good Stock',
      label: 'Healthy (>25% Shelf Life)',
    },
  ];

    const batchQuantityOptions = [
    { key: 0, value: '', label: 'All Batches' },
    { key: 1, value: 'POSITIVE_QUANTITY_BATCHES', label: 'Positive Quantity Batches' },
    { key: 2, value: 'NEGATIVE_QUANTITY_BATCHES', label: 'Negative Quantity Batches' },
    { key: 3, value: 'ZERO_QUANTITY_BATCHES', label: 'Zero Quantity Batches' },
  ];

  return (
    <div className="doc-list__wrapper doc-list__tab-content">
      <div className="ant-row">
        <div className="ant-col-xs-24">
          {!selectedSkuProduct && (
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={searchKeyword}
                        placeholder="search for batch.."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                            setLimit(10);
                            setCall(!call);
                          }
                        }}
                        onChange={(event) => {
                          setSearchKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(searchKeyword);
                          setCurrentPage(1);
                          setLimit(10);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right" />
            </div>
          )}
          <div className="flex-align-c" style={{ gap: '10px' }}>
            <UserSavedFilterViewSelector
              selectedFilterView={selectedFilterView}
              onChangeTab={(currentSelectedView) => {
                setSelectedFilterView(() => {
                  const currentSelectedViewFilters = currentSelectedView.filters;

                  const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                  const _batchDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

                  let _batchStartDate = '';
                  let _batchEndDate = '';

                  if (_batchDateRangeType === '' || _batchDateRangeType === dateRangePresets.CUSTOM) {
                    // No action needed for empty or custom date range type
                  } else {
                    const date = dateRangePresetsValues(_batchDateRangeType);
                    const [start, end] = date;
                    _batchStartDate = start;
                    _batchEndDate = end;
                    filterValue.startDate = _batchStartDate;
                    filterValue.endDate = _batchEndDate;
                  }

                  filterValue.batchDateRangeType = _batchDateRangeType;

                  const _expiryDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'expiryStartDate', valueOnly: false }).date_range_type;

                  let _expiryStartDate = '';
                  let _expiryEndDate = '';

                  if (_expiryDateRangeType === '' || _expiryDateRangeType === dateRangePresets.CUSTOM) {
                    // No action needed for empty or custom date range type
                  } else {
                    const date = dateRangePresetsValues(_expiryDateRangeType);
                    const [start, end] = date;
                    _expiryStartDate = start;
                    _expiryEndDate = end;
                    filterValue.expiryStartDate = _expiryStartDate;
                    filterValue.expiryEndDate = _expiryEndDate;
                  }

                  filterValue.expiryDateRangeType = _expiryDateRangeType;

                  const tempFilterValues = filterValue;

                  setCurrentPage(1);
                  setLimit(tempFilterValues.limit || limit);
                  setSearchKeyword(tempFilterValues.keyword);
                  setAvailableStocks(tempFilterValues.quantity_class);
                  setIsExpired(tempFilterValues.isExpired);
                  setSelectedTenant(tempFilterValues.tenant);
                  setSelectedDepartment(tempFilterValues.department_id);
                  setExpiryStatus(tempFilterValues.expiry_status);
                  setSelectedCategory(tempFilterValues.categories);
                  setStartDate(tempFilterValues.startDate);
                  setEndDate(tempFilterValues.endDate);
                  setBatchDateSelectedIntervalDateRangeType(tempFilterValues.batchDateRangeType);
                  setSortOrderByProductName(tempFilterValues.sortOrderByProductName);
                  setSortOrderByExpiryDate(tempFilterValues.sortOrderByExpiryDate);
                  setExpiryStartDate(tempFilterValues.expiryStartDate);
                  setExpiryEndDate(tempFilterValues.expiryEndDate);
                  setExpiryDateSelectedIntervalDateRangeType(tempFilterValues.expiryDateRangeType);
                  setIsRejectedBatch(tempFilterValues.isRejectedBatch);
                  setSelectedFilterInventoryLocation(tempFilterValues.inventory_location_id);
                  setSortOrder(tempFilterValues.sortOrder || 'ASC');

                  return currentSelectedView;
                });
              }}
              currentlyAppliedFilters={currentlyAppliedFilters}
              entityName={entityNameEnum.BATCH_RESERVATION}
              setSavedFilterViews={(value) => setSavedFilterViews(value)}
              setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
              setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
              callback={() => {
                if (!isUserReadyInitial) setIsUserReadyInitial(true);
              }}
              systemDefaultUserView={systemDefaultUserView}
            />
            <div className="header__tags">
              {searchKeyword && (
                <Tag closable onClose={() => { setSearchKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                  Search results for -
                  &nbsp;
                  <span><b><i>{searchKeyword}</i></b></span>
                </Tag>
              )}
              {availableStocks && (
                <Tag closable onClose={() => { setAvailableStocks(''); setCurrentPage(1); }} color="#2d7df7">
                  Batch Qty -
                  &nbsp;
                  <span><b><i>{availableStocks.replaceAll('_', ' ')?.toProperCase()}</i></b></span>
                </Tag>
              )}
              {!isViewProduct && selectedCategory && selectedCategory.map((item, index) => {
                const categoryName = subCategories ? findCategoryNameById(subCategories, item) : null;
                return (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedCategory(selectedCategory.filter((_, i) => i !== index));
                    }}
                    color="#2d7df7"
                  >
                    Category - &nbsp;
                    <span><b>{categoryName?.toUpperCase() || ''}</b></span>
                  </Tag>
                );
              })}
              {expiryStatus && (
                <Tag closable onClose={() => { setExpiryStatus(''); setCurrentPage(1); }} color="#2d7df7">
                  Expiry Status -
                  &nbsp;
                  {expiryStatus === 'Near Expiry' && <span><b>{'NEAR EXPIRY (<25% Shelf Life)'}</b></span>}
                  {expiryStatus === 'Good Stock' && <span><b>{'HEALTHY (>25% Shelf Life)'}</b></span>}
                  {expiryStatus === 'Expired' && <span><b>EXPIRED</b></span>}
                </Tag>
              )}
              {(['ASC', 'DESC'].includes(sortOrderByExpiryDate) || ['ASC', 'DESC'].includes(sortOrderByProductName)) && (
                <Tag closable onClose={() => { setSortOrderByExpiryDate(''); setSortOrderByProductName(''); }} color="#2d7df7">
                  Sort By -
                  &nbsp;
                  {['ASC', 'DESC'].includes(sortOrderByExpiryDate) && (
                    <div className="flex-display">
                      <b>EXPIRY</b>
                      <div style={{ marginLeft: '5px' }}>
                        {sortOrderByExpiryDate === 'DESC' ? <ArrowDownOutlined /> : <ArrowUpOutlined />}
                      </div>
                    </div>
                  )}
                  {['ASC', 'DESC'].includes(sortOrderByProductName) && (
                    <div className="flex-display">
                      <b>PRODUCT NAME</b>
                      <div style={{ marginLeft: 'auto' }}>
                        {sortOrderByProductName === 'DESC' ? <ArrowDownOutlined /> : <ArrowUpOutlined />}
                      </div>
                    </div>
                  )}
                </Tag>
              )}
              {
                (startDate && endDate) ? (
                  <Tag
                    closable
                    onClose={() => {
                      setStartDate(null);
                      setEndDate(null);
                      setBatchDateSelectedIntervalDateRangeType('');
                    }}
                    color="#2d7df7"
                  >
                    {' '}
                    From:
                    &nbsp;
                    <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                    &nbsp;
                    To:
                    &nbsp;
                    <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
                  </Tag>
                ) : ''
              }
              {
                (expiryStartDate && expiryEndDate) ? (
                  <Tag
                    closable
                    onClose={() => {
                      setExpiryEndDate(null);
                      setExpiryStartDate(null);
                      setExpiryDateSelectedIntervalDateRangeType('');
                    }}
                    color="#2d7df7"
                  >
                    {' '}
                    Expiry From:
                    &nbsp;
                    <span><b>{dayjs(expiryStartDate).format('DD/MM/YYYY')}</b></span>
                    &nbsp;
                    To:
                    &nbsp;
                    <span><b>{dayjs(expiryEndDate).format('DD/MM/YYYY')}</b></span>
                  </Tag>
                ) : ''
              }
              {!!selectedDepartment && (
                <Tag
                  closable={!(Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility)}
                  onClose={() => {
                    setSelectedDepartment(null); setSelectedRowKeys(null);
                    setSelectedRows([]);
                  }}
                  color="#2d7df7"
                >
                  Department -
                  &nbsp;
                  <span><b>{departments?.data?.result?.departments?.find((department) => department?.department_id === Number(selectedDepartment))?.department_info?.department_name?.toUpperCase()}</b></span>
                </Tag>
              )}
              {selectedTenant && selectedTenant?.map((item) => (
                <div key={item}>
                  <Tag
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                </div>
              ))}
            </div>
          </div>
          <div className="doc-list__table-wrapper">
            <Table
              title={() => (
                <div className="doc-list__table-header">
                  <div className="doc-list__table-header__left">
                    {`${reservations?.count || '0'} Reservations`}
                  </div>
                  <div className="doc-list__table-header__right">
                    <div className="doc-list__filter-buttons">
                      {!!selectedRows?.length && (
                        <div className="doc-list__action-buttons" onClick={() => { handleClearResrevation(); }}>
                          <div className="action-button">
                            <H3Text text="Clear Reserved Stock" className="action-button-text" />
                          </div>
                        </div>
                      )}
                      <div className="doc-list__action-buttons" onClick={showDrawer}>
                        <div className="action-button">
                          <H3Text text="Filters" className="action-button-text" />
                          <FilterOutlined />
                        </div>
                      </div>
                    </div>
                    {!selectedSkuProduct && (
                      <div className="">
                        <Dropdown
                          overlay={(
                            <div className="custom-columns__content">
                              <div className="custom-columns__content-section">
                                <H3Text text="Visible Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={() => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                          localStorage.setItem('prcz-page-columns-reservations', JSON.stringify(visibleColumnsCopy));

                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                              {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                                <div className="custom-columns__content-section">
                                  <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                  {
                                    Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                      <div key={key}>
                                        <Checkbox
                                          disabled={fixedColumns.includes(key)}
                                          checked={visibleColumns[key]?.visible}
                                          onChange={() => {
                                            const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                            visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                            localStorage.setItem('prcz-page-columns-reservations', JSON.stringify(visibleColumnsCopy));
                                            setVisibleColumns(visibleColumnsCopy);
                                          }}
                                        >
                                          {visibleColumns[key]?.label}
                                        </Checkbox>
                                      </div>
                                    ))
                                  }
                                </div>
                              ) : ''}
                            </div>
                          )}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <div className="custom-columns__wrapper">
                            Customize Columns
                            <ControlOutlined />
                          </div>
                        </Dropdown>
                      </div>
                    )}
                    {!selectedSkuProduct && (
                      <div>
                        <Dropdown
                          overlay={(
                            <div className="custom-columns__sort-filter">
                              <H3Text
                                text={(
                                  <div className="sort-by__dropdown-option">
                                    Product Name
                                    <div className="arrow">
                                      <ArrowUpOutlined />
                                    </div>
                                  </div>
                                )}
                                className={`header__custom-dropdown__option ${sortOrderByProductName === 'ASC' ? 'header__custom-dropdown__option-selected' : ''}`}
                                onClick={() => { setSortOrderByProductName('ASC'); setSortOrderByExpiryDate(''); }}
                              />

                              <H3Text
                                text={(
                                  <div className="sort-by__dropdown-option">
                                    Product Name
                                    <div className="arrow">
                                      <ArrowDownOutlined />
                                    </div>
                                  </div>
                                )}
                                className={`header__custom-dropdown__option ${sortOrderByProductName === 'DESC' ? 'header__custom-dropdown__option-selected' : ''}`}
                                onClick={() => { setSortOrderByProductName('DESC'); setSortOrderByExpiryDate(''); }}
                              />
                              <H3Text
                                text={(
                                  <div className="sort-by__dropdown-option">
                                    Expiry Date
                                    <div className="arrow">
                                      <ArrowUpOutlined />
                                    </div>
                                  </div>
                                )}
                                className={`header__custom-dropdown__option ${sortOrderByExpiryDate === 'ASC' ? 'header__custom-dropdown__option-selected' : ''}`}
                                onClick={() => { setSortOrderByProductName(''); setSortOrderByExpiryDate('ASC'); }}
                              />
                              <H3Text
                                text={(
                                  <div className="sort-by__dropdown-option">
                                    Expiry Date
                                    <div className="arrow">
                                      <ArrowDownOutlined />
                                    </div>
                                  </div>
                                )}
                                className={`header__custom-dropdown__option ${sortOrderByExpiryDate === 'DESC' ? 'header__custom-dropdown__option-selected' : ''}`}
                                onClick={() => { setSortOrderByProductName(''); setSortOrderByExpiryDate('DESC'); }}
                              />
                            </div>
                          )}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <div className="custom-columns__wrapper">
                            Sort By
                            <SwapOutlined />
                          </div>
                        </Dropdown>
                      </div>
                    )}
                  </div>
                </div>
              )}
              showHeader
              loading={getReservationsLoading || updateFreeReservationLoading || savedFilterViewsLoading}
              size="small"
              columns={getBatchesColumn()}
              dataSource={reservationsData() || []}
              scroll={!isMobileOrPortrait && !!reservationsData()?.length ? { x: 'max-content', y: 'calc(100vh - 165px)' } : { x: 'max-content' }}
              sticky={!isMobileOrPortrait && !!reservationsData()?.length}
              bordered
              pagination={
                {
                  defaultCurrent: currentPage,
                  current: currentPage,
                  total: reservations ? reservations?.count : 0,
                  pageSize: limit,
                  showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                  onChange: (page, pageSize) => {
                    setCurrentPage(page);
                    setLimit(pageSize);
                  },
                  position: ['bottomLeft'],
                  showSizeChanger: true,
                  pageSizeOptions: [10, 25, 50, 100],
                }
              }
              rowSelection={!isMobile ? {
                onChange: (rowKeys, rows) => {
                  setSelectedRowKeys(rowKeys);
                  setSelectedRows(rows);
                },
                selectedRowKeys,
                getCheckboxProps: (record) => ({
                  disabled: selectedDepartment === null || !(selectedTenant.length === 1),
                }),
                onCell: () => ({
                  title: selectedDepartment === null && 'Select Department First',
                }),
              } : false}

            />
          </div>
          <Drawer width="390px" title="Basic Drawer" placement="right" onClose={onClose} open={open}>
            <div className="custom-drawer__header-wrapper">
              <div className="custom-drawer__header" style={{ width: '345px' }}>
                <H3Text text="Filters" className="custom-drawer__title" />
                <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={onClose} />
              </div>
              <div className="header__filter__container-inventory-lookup">
                <div className="filter__container filter__container-section" style={{ marginTop: '55px' }}>
                  <div className="filter__title"> Select Business Unit </div>
                  <TenantSelector
                    selectedTenant={selectedTenant}
                    showSearch
                    onChange={(value) => {
                      setSelectedTenant(value);
                    }}
                    placeholder="Select Business Unit"
                    isMultiple
                    hideTitle
                    includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PRODUCT, Helpers.permissionTypes.READ)}
                  />
                </div>
                <div className="filter__container filter__container-section">
                  <div className="filter__title">Batch Date</div>
                  <H3DateSelector
                    // selectedInterval={selectedInterval}
                    selectedInterval={batchDateSelectedIntervalDateRangeType}
                    startDate={startDate}
                    endDate={endDate}
                    onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                      setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                      setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                      setBatchDateSelectedIntervalDateRangeType(dateRangeType);
                      setCurrentPage(1);
                      // pushParamsToUrl(1, limit, user?.tenant_info?.org_id, selectedTenant, sortOrder, isExpired, searchKeyword, getFormattedDate(date[0])?.valueOf(), getFormattedDate(date[1])?.valueOf(), selectedDepartment, expiryStartDate, expiryEndDate, sortOrderByProductName, sortOrderByExpiryDate, '', selectedFilterInventoryLocation, isRejectedBatch, selectedCategory, '', availableStocks);
                    }}
                  />
                </div>
                <div className="filter__container filter__container-section">
                  <div className="filter__title">Select Department</div>
                  <SelectDepartment
                    noDropdownAlign
                    title="Select Department"
                    hideTitle
                    selectedDepartment={selectedDepartment && Number(selectedDepartment)}
                    onChange={(value) => {
                      getInventoryLocations('', '', null, true, Helpers.getValueFromUrl('tenant') || selectedTenant || user?.tenant_info?.tenant_id, selectedDepartment?.toString());
                      setSelectedDepartment(value?.department_id || '');
                      setCurrentPage(1);
                    }}
                    disabled={getBatchesDataLoading || (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility)}
                  />
                </div>
                <div className="filter__container filter__container-section">
                  <div className="filter__title">Warehouse Bin</div>
                  <PRZSelect
                    disabled={!(selectedTenant.length === 1)}
                    value={selectedFilterInventoryLocationName}
                    loading={getInventoryLocationsLoading}
                    filterOption={false}
                    showSearch
                    onChange={(value) => {
                      setSelectedFilterInventoryLocation(value);
                      setSelectedFilterInventoryLocationName(inventoryLocations?.inventory_location?.find((item) => item.inventory_location_id == value)?.inventory_location_path);
                    }}
                    onSearch={(keyword) => {
                      getInventoryLocations(selectedFilterTenantDepartment || '', keyword, null, true, Helpers.getValueFromUrl('tenant') || selectedTenant || user?.tenant_info?.tenant_id, selectedDepartment?.toString());
                    }}
                  >
                    <Option key={0} value="">All Locations</Option>
                    {
                      inventoryLocations?.inventory_location?.filter((item) => item?.is_active)?.map((item) => (
                        <Option
                          key={item?.inventory_location_id}
                          value={item?.inventory_location_id}
                        >
                          <H3Text text={item?.inventory_location_path} className="create-new-batch__location-item" />
                        </Option>
                      ))
                    }
                  </PRZSelect>
                </div>

                {(isViewProduct ? expiryDays > 0 : true) && (
                  <div className="filter__container filter__container-section">
                    <div className="filter__title">Expiry Date</div>
                    <H3DateSelector
                      selectedInterval={expiryDateSelectedIntervalDateRangeType}
                      startDate={expiryStartDate}
                      endDate={expiryEndDate}
                      onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                        setExpiryStartDate(dayjs(date[0])?.startOf('day').valueOf());
                        setExpiryEndDate(dayjs(date[1])?.endOf('day').valueOf());
                        setExpiryDateSelectedIntervalDateRangeType(dateRangeType);
                        setCurrentPage(1);
                        // pushParamsToUrl(1, limit, user?.tenant_info?.org_id, selectedTenant, sortOrder, isExpired, searchKeyword, startDate, endDate, selectedDepartment, getFormattedDate(date[0])?.valueOf(), getFormattedDate(date[1])?.valueOf(), sortOrderByProductName, sortOrderByExpiryDate, '', selectedFilterInventoryLocation, isRejectedBatch, selectedCategory, '', availableStocks);
                      }}
                    />
                  </div>
                )}

                {(isViewProduct ? expiryDays > 0 : true) && (
                  <div className="filter__container filter__container-section">
                    <div className="filter__title"> Expiry Status  </div>
                    <PRZSelect
                      value={expiryStatus}
                      disabled={getBatchesDataLoading}
                      onChange={(value) => { setExpiryStatus(value); }}
                      options={batchStatusOptions}
                    />

                  </div>
                )}

                {!isViewProduct && (
                  <div className="filter__container filter__container-section">
                    <div className="filter__title">Product Category </div>
                    <CategoryFilterNew
                      selectedCategory={selectedCategory}
                      containerClassName="section-status"
                      hideTitle
                      placeholder="Product Category"
                      style={{
                        width: '100%',
                        height: '28px',
                        border: 'none',
                        borderRadius: '3px',
                      }}
                      onChange={(value, title) => {
                        setSelectedCategory(value);
                      }}
                      allowClear
                    />
                  </div>
                )}

                <div className="filter__container filter__container-section">
                  <div className="filter__title">Available Stock</div>
                  <PRZSelect
                    allowClear
                    value={availableStocks}
                    filterOption={false}
                    onChange={(value) => (setAvailableStocks(value))}
                    showSearch={false}
                    placeholder="Select Available Stock"
                    maxTagCount="responsive"
                    options={batchQuantityOptions}
                  />
                </div>
                <br />
              </div>
            </div>
          </Drawer>

        </div>
      </div>
      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`${selectedBatch?.product_sku_name} - ${selectedBatch?.internal_sku_code}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          description={selectedBatch?.description}
          customFields={selectedBatch?.custom_fields}
          fields={ListScreenKeys({ documentData: selectedBatch, MONEY, priceMasking })}
        />
      </Drawer>
    </div>
  );
}

const mapStateToProps = ({
  UserReducers, InventoryLocationReducers,
  BatchReducers, DepartmentReducers, CategoryReducers, ReservationReducers,
}) => ({
  user: UserReducers.user,
  org: UserReducers.org,
  getReservationsLoading: BatchReducers.getReservationsLoading,
  reservations: BatchReducers.reservations,
  inventoryLocations: InventoryLocationReducers.inventoryLocations,
  departments: DepartmentReducers.departments,
  getInventoryLocationsLoading: InventoryLocationReducers.getInventoryLocationsLoading,
  getCategoriesLoading: CategoryReducers.getCategoriesLoading,
  categories: CategoryReducers.categories,
  MONEY: UserReducers.MONEY,
  subCategories: CategoryReducers.subCategories,
  updateFreeReservationLoading: ReservationReducers.updateFreeReservationLoading,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getBatchesLoading: (payload, callback) => dispatch(StockMasterActions.getBatchesLoading(payload, callback)),
  getCategories: (orgId, page, limit, searchKeyword) => dispatch(CategoryActions.getCategories(orgId, page, limit, searchKeyword)),
  getReservations: (payload, callback) => dispatch(BatchActions.getReservations(payload, callback)),
  getTenants: (page, keyword, isVerified, orgId, limit, callback, tenantId) => dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId, limit, callback, tenantId)),
  getInventoryLocations: (tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable, tenantId, departmentId) => dispatch(InventoryLocationActions.getInventoryLocations(tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable, tenantId, departmentId)),
  downloadDocument: (payload, document) => dispatch(AnalyticsActions.downloadDocument(payload, document)),
  updateFreeReservation: (payload, callback) => dispatch(ReservationActions.updateFreeReservation(payload, callback)),
  retestQualityCheck: (payload, callback) => dispatch(QualityCheckActions.retestQualityCheck(payload, callback)),
  getBatches: (tenantProductId, batchNumber, batchId, page, limit, availableQuantity, tenantDepartmentId, productSkuId, departmentId, selectedTenant, startDateEpoch,
    endDateEpoch, expiryStartDateEpoch, expiryEndDateEpoch, inventoryLocation, category, expiryStatus, availableStock) => dispatch(BatchActions.getBatches(tenantProductId, batchNumber, batchId, page, limit, availableQuantity, tenantDepartmentId, productSkuId, departmentId, selectedTenant, startDateEpoch,
      endDateEpoch, expiryStartDateEpoch, expiryEndDateEpoch, inventoryLocation, category, expiryStatus, availableStock)),
});

BatchReservations.propTypes = {
  history: PropTypes.func,
  departments: PropTypes.any,
  inventoryLocations: PropTypes.any,
  getInventoryLocations: PropTypes.func,
  getInventoryLocationsLoading: PropTypes.bool,
  user: PropTypes.any,
  org: PropTypes.any,
  getCategories: PropTypes.func,
  getBatchesDataLoading: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BatchReservations));
